import GLArrayBuffer from 'nanogl/arraybuffer'
import Fbo from 'nanogl/fbo'
import Program from 'nanogl/program'
import { GLContext } from 'nanogl/types'

import glsl_frag from './fxaa.frag'
import glsl_vert from './fxaa.vert'

const fsData = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1])

export default class FXAA {
  fbo: Fbo
  fsPlane: GLArrayBuffer
  prg: Program
  width: number = 0
  height: number = 0

  constructor(gl: GLContext) {
    this.fbo = new Fbo(gl)
    this.fbo.attachColor(gl.RGB, gl.UNSIGNED_BYTE)
    this.fbo.resize(4, 4)
    this.fbo.getColorTexture().clamp()
    this.fbo.getColorTexture().setFilter(false, false, false)

    this.prg = new Program(gl, glsl_vert(), glsl_frag())

    this.fsPlane = new GLArrayBuffer(gl, fsData)
    this.fsPlane.attrib('aTexCoord0', 2, gl.FLOAT)
  }

  resize(w: number, h: number) {
    if (w == this.width && h == this.height) return
    this.fbo.resize(w, h)
  }

  render() {
    this.prg.use()
    this.prg.uTexelSize(1 / this.fbo.width, 1 / this.fbo.height)
    this.prg.tInput(this.fbo.getColorTexture())

    this.fsPlane.attribPointer(this.prg)
    this.fsPlane.drawTriangleStrip()
  }
}
